import type { IAction } from "@bbj-types/action";
import type { IAddress } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import type { TMissedReason } from "@complex/Actions/Modal/logics/types";
import type { IDateRange } from "@styleguide";
import { useCallback } from "react";
import { axiosAction } from "./axios";

// executionPeriod: used for action with approach type, otherwise we use executionDate and endDate
export interface IActionBatchCreate {
  isAutoGenerate: boolean;
  status: IAction["status"];
  type: string;
  address?: IAddress;
  apply?: ObjectId;
  candidate?: ObjectId;
  challenges?: ObjectId[];
  comments?: string;
  contactChannel?: string;
  deadlineDate?: Date;
  endOfContract?: Date;
  executionDate?: Date;
  jobSituation?: string;
  missedReason?: TMissedReason["value"];
  owner?: ObjectId;
  timeSpent?: number;
  title?: string;
  endDate?: Date;
  approach?: ObjectId;
  executionPeriod?: IDateRange; // used for action with approach type, otherwise we use executionDate and endDate
}

export const useBatchCreateActions = () => {
  const [state, execute, cancel] = axiosAction<ObjectId[], IActionBatchCreate[], unknown>(
    {
      url: "/batch",
      method: "post",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (actions: IActionBatchCreate[]) => {
      return execute({ data: actions });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
